/** @jsxImportSource @emotion/react */
import { Controls } from 'components/landing/ui';

const ReviewSelect = ({ currentReviewIndex, selectReview, reviews }) => {
  const total = reviews.length;

  const handlePrev = () => {
    selectReview(currentReviewIndex - 1);
  };

  const handleNext = () => {
    selectReview(currentReviewIndex + 1);
  };

  return (
    <Controls
      title="Отзывы"
      current={currentReviewIndex + 1}
      total={total}
      onNext={handleNext}
      onPrev={handlePrev}
    />
  );
};

export default ReviewSelect;
